export { InfoTooltip } from './InfoTooltip';
export type { InfoTooltipProps } from './InfoTooltip';
